<script setup>
defineOptions({
  name: 'CheckinsSettingsToolbar'
})
</script>

<template>
  <div class="cst-Toolbar">
    <div class="cst-Toolbar_Description">
      <slot name="description">
        {{ $t('checkins.settings.description') }}
      </slot>
    </div>

    <slot name="action" />
  </div>
</template>

<style lang="scss" scoped>
$pt: 16px;
$pb: 35px;

.cst-Toolbar {
  width: 100%;
  max-width: var(--ob-automations-page-width);
  padding: $pt $page-right-padding $pb $page-left-padding;
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  min-height: calc(#{$pt} + #{$pb} + 32px);
}

.cst-Toolbar_Description {
  color: $dark-2;
  font-size: $fs-14;
  line-height: 20px;
}
</style>
